export const MuiListItemIconTheme = () => {
    return {
        defaultProps: {},
        styleOverrides: {
            alignItemsFlexStart: {},
            root: {
                "&[class][class]": {
                    minWidth: "unset",
                },
            },
        },
    };
};
